import { User } from 'lucide-react'
import { Link } from '@tanstack/react-router'
import { useTranslation } from '@kostbar/i18n'
import { useAuth } from '@/features/auth/hooks/use-auth'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { LanguageSwitcher } from '@/shared/components/language-switcher'
import { LocationSwitcher } from '@/shared/components/layout/location-switcher'

export function Header() {
  const { user, logout } = useAuth()
  const { t: tNav } = useTranslation('nav')
  const { t: tCommon } = useTranslation('common')

  // The app title used to sit here. It was on screen twice — sidebar and header — and the freed
  // slot now belongs to the location, which scopes everything below it
  // (CHG-2026-09-manager-reporting, D16). The sidebar keeps the title.
  return (
    <header className="h-16 border-b border-border bg-background flex items-center justify-between px-6">
      <LocationSwitcher />

      <div className="flex items-center gap-2">
        <LanguageSwitcher />

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon">
              <User className="w-5 h-5" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <div className="px-2 py-1.5 text-sm text-muted-foreground">
              {user?.email}
            </div>
            <Link to="/profile">
              <DropdownMenuItem>{tNav('profile')}</DropdownMenuItem>
            </Link>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={logout}>
              {tCommon('logout')}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  )
}
